// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3b84eae0","455":"44ae5c54","488":"ac66efa8"}[chunkId] + ".chunk.js";
};